"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Comparison = void 0;
var _react = _interopRequireWildcard(require("react"));
var _mediaQuery = require("b2b-components/utils/mediaQuery");
var _classnames = _interopRequireDefault(require("classnames"));
var _common = require("../common");
var _utils = require("../utils");
var _Arrows = require("./Arrows");
var _HeaderRow = require("./HeaderRow");
var _Rows = require("./Rows");
var _StickyRow = require("./StickyRow");
require("./Comparison.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Comparison = exports.Comparison = /*#__PURE__*/(0, _react.forwardRef)((_ref, headerRowRef) => {
  let {
    items,
    slideIndex,
    isStickyRowVisible,
    stickyRowTop = 0,
    onSlideChange,
    maxSlideIndex,
    emptyColumnText,
    className,
    areDifferencesHighlighted,
    visibleColumns,
    numberOfItems
  } = _ref;
  const {
    header,
    sticky,
    rows
  } = (0, _utils.getComparisonRowsFromItems)(items);
  const hasSliderArrows = _mediaQuery.isDesktop ? numberOfItems > _common.MAX_NUMBER_OF_COLUMNS_VISIBLE : numberOfItems > _common.MIN_NUMBER_OF_COLUMNS_VISIBLE;
  const hasStickyRow = sticky.length > 0;
  const cellClassName = 'cds-ComparisonTable-Cell';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(`cds-Comparison--${visibleColumns}Columns`, {
      [`cds-Comparison--Index${slideIndex}`]: slideIndex !== null,
      'cds-Comparison--WithStickyRow': hasStickyRow
    })
  }, hasStickyRow && /*#__PURE__*/_react.default.createElement(_StickyRow.StickyRow, {
    row: sticky,
    isVisible: isStickyRowVisible,
    top: stickyRowTop,
    cellClassName: cellClassName
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(className, 'cds-ComparisonTable')
  }, hasSliderArrows && /*#__PURE__*/_react.default.createElement(_Arrows.Arrows, {
    top: stickyRowTop,
    slideIndex: slideIndex,
    maxSlideIndex: maxSlideIndex,
    onSlideChange: onSlideChange
  }), /*#__PURE__*/_react.default.createElement("div", {
    ref: headerRowRef
  }, /*#__PURE__*/_react.default.createElement(_HeaderRow.HeaderRow, {
    row: header,
    hasSliderArrows: hasSliderArrows,
    emptyColumnText: emptyColumnText,
    cellClassName: cellClassName
  })), /*#__PURE__*/_react.default.createElement(_Rows.Rows, {
    rows: rows,
    areDifferencesHighlighted: areDifferencesHighlighted,
    cellClassName: cellClassName
  })));
});
Comparison.displayName = 'Comparison';
//# sourceMappingURL=Comparison.js.map